<!-- @Version: 1.0.9 -->
@if (done$$ () == true) {
   <form [formGroup]="fgRating" data-testid="ratingcontainer">
      <mat-radio-group class="rating-row show-desktop" [formControlName]="FC_RATING.RATINGBUTTON" [class]="this.fieldItem.attribute_4">
         @for(rating of sFieldItemRating.ratingButtons; track rating; let idx=$index) {
             <mat-radio-button (mouseover)="!fgRating.get(FC_RATING.RATINGBUTTON)?.disabled ? hoverEvent(idx) : false"  (mouseleave)="isHovered=false"
               class="flex-item rating-button"
               [class.disabled]="fgRating.get(FC_RATING.RATINGBUTTON)?.disabled"
               [class.active]="fgRating.value[FC_RATING.RATINGBUTTON] != null && fgRating.value[FC_RATING.RATINGBUTTON] != undefined && fgRating.value[FC_RATING.RATINGBUTTON] !== '' && !isHovered
               && (idx + +(fieldItem.attribute_5 ?? 0) == fgRating.value[FC_RATING.RATINGBUTTON] 
               || ((idx + +(fieldItem.attribute_5 ?? 0) < fgRating.value[FC_RATING.RATINGBUTTON])))
               ? true : false"
               [class.number-rating]="fieldItem.attribute_4 == ICON.NUMBER ? true:false"
               [class.icon-hover]="!fgRating.get(FC_RATING.RATINGBUTTON)?.disabled && isHovered && idx + +(fieldItem.attribute_5 ?? 0) <= currentItemHover ? true:false"
               [attr.data-testid]="'mat-rating' + idx"
               [value]="idx + +(fieldItem.attribute_5 ?? 0)"
               [checked]="false"
               tabindex="0"
               [aria-label]="(idx + +(fieldItem.attribute_5 ?? 0)).toString()"
               [color]="TRANSLATE_PATH_SHARED.COLOR_RATING | translateDesign"
               [attr.color]="TRANSLATE_PATH_SHARED.COLOR_RATING | translateDesign"
            >
               @if (fieldItem.attribute_4 != ICON.NUMBER) {
                  <div cdkMonitorElementFocus class="pointer label" (keyup.Space)="!fgRating.get(FC_RATING.RATINGBUTTON)?.disabled ? onKeyboardSpace(idx) : false" >
                     <mat-icon  data-testid="rating-icon" >
                        {{rating.icon}}
                     </mat-icon>
                  </div>
               }
               @if (fieldItem.attribute_4 == ICON.NUMBER) {
                  <div cdkMonitorElementFocus class="pointer label" (keyup.Space)="!fgRating.get(FC_RATING.RATINGBUTTON)?.disabled ? onKeyboardSpace(idx) : false" data-testid="rating-number">
                     <div data-testid="number-value" class="number-value">
                        <span>{{idx + sFieldItemRating.minNumber}}</span>
                     </div>
                  </div>
               }
            </mat-radio-button>
         }

      </mat-radio-group>
      <mat-slider class="show-mobile" max-width="100%" thumbLabel [min]="fieldItem.attribute_5 ?? 0" [max]="(fieldItem.attribute_5 | getMax : fieldItem.attribute_3)" step="1" showTickMarks [displayWith]="formatLabel" discrete data-testid="rating-slider">
         <label for="silder"><input matSliderThumb [formControlName]="FC_RATING.RATINGBUTTON" #slider></label>
      </mat-slider>
      <div data-width="100%" class="rating-label">
         <div class="begin">
            @if (fieldItem.attribute_1) {
              <mat-hint data-testid="lowValue" [attr.for]="slider">{{fieldItem.attribute_1}}</mat-hint>
            }
         </div>
         <div class="end">
            @if (fieldItem.attribute_2) {
              <mat-hint data-testid="highValue">{{fieldItem.attribute_2}}</mat-hint>
            }
         </div>
      </div>
      <div class="error-messages">
         @if (fgRating.errors && fgRating.errors.required && !fgRating.errors.valid && fgRating.dirty) {
         <mat-error [attr.data-testid]="'error-required'">{{sFieldItemRating.errorCodes.errorCodeRequired}}</mat-error>
         }
         @if (fgRating.errors && fgRating.errors.valid) {
         <mat-error [attr.data-testid]="'error-valid'">{{sFieldItemRating.errorCodes.errorCodeValid}}</mat-error>
         }
         @if (fieldItem.required && !fgRating.get(FC_RATING.RATINGBUTTON)?.disabled && !(fgRating.errors && fgRating.errors.required && !fgRating.errors.valid && fgRating.dirty)) {
         <mat-hint [attr.data-testid]="'hint-required'">{{TRANSLATE_PATH_SHARED.REQUIRED | translateDesign}}</mat-hint>
         }
         @if (!(fgRating.errors && fgRating.errors.required && !fgRating.errors.valid && fgRating.dirty) && !(fgRating.errors && fgRating.errors.valid) && !(fieldItem.required && !fgRating.get(FC_RATING.RATINGBUTTON)?.disabled && !(fgRating.errors && fgRating.errors.required && !fgRating.errors.valid && fgRating.dirty))) {
         <mat-hint> </mat-hint>
         }
      </div>
   </form>
}